import React from "react";
import { Container } from "./styles";
import PageBuilderComponent from "./PageBuilder";
import GoBackComponent, { GoBackProps } from "./GoBack";
import GridOutlineComponent from "@/components/GridOutline";

// Cast to fix React 17 + @types/react 18 compatibility issue
const PageBuilder = PageBuilderComponent as any;
const GoBack = GoBackComponent as any;
const GridOutline = GridOutlineComponent as any;

type Props = {
  pageBuilder: any[] | null;
  goBackLink: GoBackProps | null;
  isHomepage: boolean;
};

const Marketing: React.FC<Props> = (props) => {
  const { pageBuilder, goBackLink, isHomepage } = props;
  return (
    <Container>
      <GridOutline />
      {goBackLink && <GoBack {...goBackLink} />}
      {pageBuilder && (
        <PageBuilder
          blocks={pageBuilder}
          isBackButton={goBackLink !== null}
          isHomepage={isHomepage}
        />
      )}
    </Container>
  );
};

export default Marketing;
